module.exports = import("https://esm.sh/@putout/processor-html");;